import React from 'react';
import Skeleton from '../../../components/Skeleton';

const SuspenseFallback = () => {
    return (
        <div className='checkout-content block width-100percent margin-bottom-2rem'>
            <div className='checkout-view display-flex flex-direction-column checkout-view--container padding-top-2rem'>
                <Skeleton/>
            </div>
        </div>
    )
};

export default React.memo(SuspenseFallback);